import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import TeamHistory from "components/TeamHistory";
import OfferTable from "components/OfferTable";
import instagramLogo from "public/instagram-logo.svg";
import facebookLogo from "public/facebook-logo.svg";

import "css/main.css";
import "css/style.css";

import { getDocumentById } from "services/documents_service";

import unknownUser from "img/unknown_user.png";

import Topnav from "components/Topnav";
import { getAccount } from "services/account_service";
import { getOffers } from "services/offer_service";

function Acc() {
  const [account, setAccount] = useState({});
  const [clubOffers, setClubOffers] = useState([]);
  const { accId } = useParams();
  const [img, setImg] = useState(unknownUser);

  useEffect(() => {
    async function fetchData() {
      const acc = await getAccount(accId);
      setAccount(acc);

      let offers = await getOffers(accId);
      setClubOffers(offers);

      if (acc.attributes?.logo?.data?.id) {
        let docs = await getDocumentById(acc.attributes?.logo?.data?.id);

        if (docs.attributes?.body?.data?.attributes?.url) {
          setImg(docs.attributes?.body?.data?.attributes?.url);
        }
      }
    }

    fetchData();
  }, []);

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <section className="section">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li className="is-active">Perfis</li>
            </ul>
          </nav>

          <div className="hero is-footsolution">
            <div className="columns">
              <div className="column">
                <h1 className="title is-3">Perfil</h1>
              </div>
            </div>
          </div>

          <div className="block">
            <label className="label">
              {account.attributes?.role === "Clube"
                ? "Logo do clube"
                : "Imagem de perfil"}
            </label>
            <div className="field">
              <img
                style={{ width: "200px", height: "175px" }}
                alt="personImage"
                src={`${img}`}
              ></img>
            </div>
          </div>

          <div className="block">
            <div className="field">
              <label className="label">Nome</label>
              <p className="control">{account?.attributes?.name}</p>
            </div>
          </div>

          <div className="block">
            <div className="field">
              <label className="label">Email</label>
              <p className="control">
                {account?.attributes?.users.data[0]?.attributes?.email}
              </p>
            </div>
          </div>

          <div className="block">
            <div className="field">
              <label className="label">Número de telemóvel</label>
              <p className="control">{account?.attributes?.phone_number}</p>
            </div>
          </div>
          {account?.attributes?.role !== "Clube" && (
            <>
              <div className="block">
                <div className="field">
                  <label className="label">Data de nascimento</label>
                  <p className="control">
                    {account?.attributes?.date_of_birth}
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Nacionalidade</label>
                  <p className="control">{account?.attributes?.nationality}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Naturalidade</label>
                  <p className="control">{account?.attributes?.naturality}</p>
                </div>
              </div>
            </>
          )}

          {account?.attributes?.role === "Clube" && (
            <>
              <div className="block">
                <div className="field">
                  <label className="label">Foto Equipamento</label>
                  <p className="control">{account?.attributes?.locality}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Localidade</label>
                  <p className="control">{account?.attributes?.locality}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Nome do estádio</label>
                  <p className="control">{account?.attributes?.stadium}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Site</label>
                  <p className="control">{account?.attributes?.site}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Nome Presidente</label>
                  <p className="control">
                    {account?.attributes?.president_name}
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Ano de fundação</label>
                  <p className="control">
                    {account?.attributes?.foundation_year}
                  </p>
                </div>
              </div>
              {account?.attributes?.instagram_link && (
                <a
                  rel="noreferrer"
                  href={
                    "https://www.instagram.com/" +
                    account?.attributes?.instagram_link
                  }
                  target="_blank"
                  className="icon"
                >
                  <img
                    src={instagramLogo}
                    alt=""
                    style={{ height: "45px", width: "45px", margin: "auto" }}
                  />
                </a>
              )}
              &nbsp;&nbsp;&nbsp;
              {account?.attributes?.facebook_link && (
                <a
                  rel="noreferrer"
                  href={
                    "https://www.facebook.com/" +
                    account?.attributes?.facebook_link
                  }
                  target="_blank"
                  className="icon"
                >
                  <img
                    src={facebookLogo}
                    alt=""
                    style={{ height: "45px", width: "45px", margin: "auto" }}
                  />
                </a>
              )}
              <label className="label">Vagas do clube</label>
              <OfferTable isReadOnly={true} offerList={clubOffers}></OfferTable>
            </>
          )}

          {account?.attributes?.role === "Jogador" && (
            <>
              <div className="block">
                <div className="field">
                  <label className="label">Altura (cm)</label>
                  <p className="control">{account?.attributes?.height}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Peso (kg)</label>
                  <p className="control">{account?.attributes?.weight}</p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Pé preferêncial</label>
                  <p className="control">
                    {account?.attributes?.preferred_foot}
                  </p>
                </div>
              </div>
              <div className="block">
                <div className="field">
                  <label className="label">Posição(ões)</label>
                  <p className="control">
                    {account?.attributes?.position.join(", ")}
                  </p>
                </div>
              </div>

              <div className="field">
                <label className="label">Histórico de equipas</label>
                <TeamHistory
                  type={account?.attributes?.role}
                  history={account?.attributes?.team_histories.data}
                  isReadOnly={true}
                ></TeamHistory>
              </div>
            </>
          )}
        </section>
      </div>
    </div>
  );
}

export default Acc;
